
import { supabase } from '@/lib/supabase/client';
import { Product } from '@/lib/supabase/products/types';
import { setOrganizationIdCache } from '@/lib/supabase/products/organization';

export const fetchProductByUUID = async (
  productId: string,
  shopId?: string | null,
  organizationId?: string | null,
  setOrganizationId?: (id: string | null) => void
): Promise<Product | null> => {
  try {
    console.log("Fetching product by UUID:", productId);
    
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('id', productId)
      .single();
    
    if (error) {
      console.error("Error fetching product by UUID:", error);
      return null;
    }
    
    if (data) {
      console.log("Product found by UUID:", data.name);
      
      // If we have an organization_id from the product and a setter, set it
      if (data.organization_id && setOrganizationId) {
        console.log("Setting organization ID from product:", data.organization_id);
        setOrganizationId(data.organization_id);
        setOrganizationIdCache(data.organization_id);
      }
      
      return data as Product;
    }
    
    return null;
  } catch (error) {
    console.error("Exception fetching product by UUID:", error);
    return null;
  }
};
